import {
  type EvaluationTitleAudience,
  getEvaluationTitle,
} from "./evaluationTitle";

export function buildParcoursDescription(
  evals: { typeEval: string; template?: string }[],
  audience: EvaluationTitleAudience = "interne",
): string {
  return evals.map((e) => getEvaluationTitle(e, audience)).join(" • ");
}
